<p-card styleClass=" card-pronto-pago" *ngIf="false">
  <div class="d-flex flex-row justify-content-between">
    <i class="pi pi-user pt-3" [style]="{ 'font-size': '1.5rem' }"></i>
    <div class="card-pronto-pago-texto pt-2">
      <p class="lh-1">
        <span class="fs-5">
          ¡Soy primer ingreso y tengo beneficio por pronto pago!
        </span>
        <br />
        <span class="d-block mt-2 fs-6"
          >Fecha límite para recibir este beneficio: 10 de enero de 2024</span
        >
      </p>
    </div>
    <div class="flex justify-content-center pt-4">
      <p-inputSwitch [(ngModel)]="checked"></p-inputSwitch>
    </div>
  </div>
</p-card>

<p-card class="text-center" styleClass="mt-3">
  <p-badge value="Total de Contado" size="large" severity="success"></p-badge>
  <h2 class="fw-bold mt-3">{{ total }}</h2>

  <div class="mt-5">
    <p-table
      *ngIf="conceptoData.length > 0"
      class="resumen-table"
      [value]="conceptoData"
      [styleClass]="'p-datatable-gridlines p-datatable-sm'"
    >
      <ng-template pTemplate="header">
        <tr>
          <th scope="col">Concepto</th>
          <th scope="col">Importe</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-concepto>
        <tr>
          <td [class]="concepto.class">
            <div class="d-flex align-items-center">
              {{ concepto.concepto }}
              <app-label-tooltip
                *ngIf="concepto.etiqueta"
                class="m-2"
                [etiqueta]="concepto.etiqueta"
              ></app-label-tooltip>
            </div>
          </td>
          <td [class]="concepto.class">{{ concepto.importe }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  @if (seguroCoberturaData.length > 0) {
  <div class="mt-5">
    <p-table
      [value]="seguroCoberturaData"
      class="resumen-table"
      styleClass="p-datatable-sm"
    >
      <ng-template pTemplate="header">
        <tr>
          <th scope="col">Seguro y Cobertura</th>
          <th scope="col"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-seguro>
        <tr>
          <td [class]="seguro.class">
            <div class="d-flex align-items-center">
              {{ seguro.concepto }}
              <app-label-tooltip
                *ngIf="seguro.etiqueta"
                class="m-2"
                [etiqueta]="seguro.etiqueta"
              ></app-label-tooltip>
            </div>
          </td>
          <td [class]="seguro.class">{{ seguro.importe }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  }
</p-card>

<br />

<p-card class="text-center">
  <p-badge [value]="parcialidades" size="large" severity="success"></p-badge>

  <div class="mt-3">
    <p-table
      [value]="parcialidadesData"
      class="resumen-table"
      styleClass="p-datatable-sm"
    >
      <ng-template pTemplate="body" let-parcialidad>
        <tr>
          <td [class]="parcialidad.class">
            <div class="d-flex align-items-center">
              {{ parcialidad.parcialidad }}
              <app-label-tooltip
                *ngIf="parcialidad.etiqueta"
                class="m-2"
                [etiqueta]="parcialidad.etiqueta"
              ></app-label-tooltip>
            </div>
          </td>
          <td [class]="parcialidad.class">{{ parcialidad.importe }}</td>
        </tr>
      </ng-template>
    </p-table>
    <p
      class="text-start text-description mt-3"
      [innerHTML]="textoSeguroParcialidades"
    ></p>

    <p
      class="text-start text-description mt-3"
      *ngIf="
        this.resumenEmmiterData && this.resumenEmmiterData?.nivel?.clave != '03'
      "
      [innerHTML]="textoSeguroAportacion"
    ></p>
  </div>
</p-card>

<br />

<div class="text-center d-flex justify-content-center align-items-center">
  <p-button
    label="Reiniciar simulador"
    icon="pi pi-sync"
    styleClass="reiniciar"
    [style]="{ 'margin-right': '10px' }"
    (onClick)="reiniciar()"
  ></p-button>

  <app-label-tooltip
    [isRequired]="true"
    styleClass=""
    titleLabel=""
    etiqueta="reset"
    [isRequired]="false"
  ></app-label-tooltip>
</div>

<p
  class="text-start text-description mt-3"
  [innerHTML]="textoSeguroNotificacion"
></p>
